<div class="flex-1 max-w-full h-full">
<ng-template licensingTierTemplateInsert></ng-template>
</div>
